import React from 'react';
import { Box, Dialog, Grid, IconButton, Stack, Typography } from '@mui/material';
import styles from '../../../../../custom/style.module.css';
import { CustomDialogContent, CustomDialogTitle, StyledCard } from 'custom/components';
import { CloseIconBtn } from 'custom/constants';
import TableWrapper from 'components/pages/common/TanStackTableWrapper';
import buildupStyles from './buildup.module.css';
import { Forward } from '@mui/icons-material';

const AwbInfoModal = (props) => {

  const columns = [
    {
      accessorKey: 'green',
      header: '',
      size: 'sm',
      cell: (info) => {
        const status = info.getValue() ? 'completed' : 'failed';
        return (
          <Stack direction='row' spacing={1}>
            <Typography component='span' className={`${buildupStyles.statusIndicator} ${buildupStyles[status]}`} />
          </Stack>
        );
      },
    },
    {
      accessorKey: 'awb#',
      header: 'AWB#',
      cell: ({ row }) => {
        console.log(row);
        return row.original.code + '-' + row.original.number;
      },
    },
    {
      accessorKey: 'org',
      header: 'Org',
    },
    {
      accessorKey: 'dest',
      header: 'Dest',
    },
    {
      accessorKey: 'pcs',
      header: 'Pcs',
    },
    {
      accessorKey: 'wgt',
      header: 'Wgt',
      cell: (info) => {
        const wgt = info.getValue();
        return (wgt ? wgt.toFixed(2) : '') + 'K';
      }
    },
    {
      accessorKey: 'remaining_pcs',
      header: 'Remaining Pcs',
      cell: (info) => {   
        const row = info.row.original;
        return row?.pcs - row?.buildup_awbs?.reduce((a, b) => parseInt(a) + parseInt(b.pcs), 0) || 0;
      }

    },
    {
      accessorKey: 'remaining_wgt',
      header: 'Remaining Wgt',
      cell: (info) => {
        const row = info.row.original;
        const remainingWgt = row?.wgt - row?.buildup_awbs?.reduce((a, b) => parseFloat(a) + parseFloat(b.wgt), 0) || 0;
        return remainingWgt.toFixed(2) + 'K';
      }
    },
    {
      accessorKey: 'spl_code',
      header: 'SPLs',
      cell: (info) => {
        const spl = info.getValue();
        if (Array.isArray(spl)) return spl.join(', ');
        return <span className={buildupStyles.splCode}>{spl?.split(',').join(', ') || ''}</span>;
      }
    },
    {
      accessorKey: 'wh_location',
      header: 'Info to Warehouse',
      cell: (info) => {
        const whLocation = info.getValue();
        return <span className={buildupStyles.whLocation}>{whLocation || '-'}</span>;
      }
    },
    {
      accessorKey: 'action',
      header: 'Action',
      cell: ({ row }) => {
        return (<>
          <IconButton size='small' title='Move to ULD' className={buildupStyles.moveToUldBtn} 
            onClick={() => props.onSearch(row.original.id)}
            disabled={props.disableMoveToUld || row?.original?.pcs - row?.original?.buildup_awbs?.reduce((a, b) => parseInt(a) + parseInt(b.pcs), 0) <= 0}
            color='primary'
          >
            <Forward fontSize='inherit' />
          </IconButton>
        </>
        );
      }
    }
  ];

  return (
    <>
      <Dialog aria-labelledby='form-dialog-title' open={props.modal == 'awb_info'} onClose={props.onClose} maxWidth='lg' fullWidth>
        <CustomDialogTitle id='form-dialog-title' className={styles.modalTitle}>
          Airwaybill List
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>

        <CustomDialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <StyledCard className={`${styles.h100}`}>
                <Box className={`${styles.tableOuter}`}>
                  <TableWrapper
                    columns={columns}
                    data={props.awbs}
                  />
                </Box>
              </StyledCard>
            </Grid>
          </Grid>
        </CustomDialogContent>
      </Dialog>
    </>
  );
};
export default AwbInfoModal;